"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _react = require('react');
var _reactredux = require('react-redux');




// Class-component `setState` for the screens converted from classes:
// - the update is merged into the state object (object or updater form,
//   applied in call order onto the pending state, as React applies them);
// - `pure: false` (React.Component) re-renders on every setState, even when
//   nothing changed; `pure: true` (React.PureComponent) skips the render when
//   the merged state is shallow-equal, as its shouldComponentUpdate did;
// - a callback runs after the commit that applied its update. The caller
//   runs the callbacks in its layout effect, after it has recorded the
//   committed props/state, so a callback reads the new values the way
//   `this.state` did. An update that carries a callback always commits, so
//   the callback cannot be lost to a bail-out. A caller whose layout effect
//   also runs componentDidUpdate (which can set state) takes the queue first
//   with `takeCallbacks()` and runs it afterwards: callbacks queued during
//   componentDidUpdate then wait for the commit that applies their update,
//   as React ran them for a class.
//
// components/VideoRooms/Room/History/helpers.ts has a smaller useClassState
// (object updates only, no pure bail-out, and it flushes in its own effect,
// so it cannot order callbacks after componentDidUpdate); merging the two is
// a follow-up.
 const useClassState = (initial, pure = false) => {
  const [state, setRawState] = _react.useState(initial)
  const callbacks = _react.useRef([])

  const setState = _react.useCallback((update, callback) => {
    if (callback) callbacks.current.push(callback)
    setRawState(prev => {
      const next = { ...prev, ...(typeof update === 'function' ? update(prev) : update) }
      return pure && !callback && _reactredux.shallowEqual.call(void 0, prev, next) ? prev : next
    })
  }, [pure])

  // Takes the callbacks queued so far; the returned function runs them.
  const takeCallbacks = _react.useCallback.call(void 0, () => {
    const queued = callbacks.current
    callbacks.current = []
    return () => queued.forEach(cb => cb())
  }, [])

  const flushCallbacks = _react.useCallback.call(void 0, () => takeCallbacks()(), [takeCallbacks])

  return [state, setState, flushCallbacks, takeCallbacks] 
}; exports.useClassState = useClassState
